import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-products',
  imports: [RouterOutlet],
  templateUrl: './products.html',
  styleUrl: './products.scss'
})
export class Products {

}
